// extracted by mini-css-extract-plugin
module.exports = {"progressDashboard":"style_progressDashboard__gOFKU","heading":"style_heading__pGzRm"};